import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[750px] flex flex-col items-center justify-center pt-20 pb-16 px-4 md:px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20abstract%20geometric%20background%20with%20soft%20warm%20coral%20and%20amber%20gradient%20overlay%2C%20subtle%20radial%20glow%20from%20center%2C%20modern%20minimal%20texture%2C%20smooth%20gradients%2C%20elegant%20atmospheric%20design%2C%20no%20text%2C%20no%20people%2C%20clean%20geometric%20composition&width=1800&height=900&seq=hero-bg-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/50 via-foreground-950/30 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto flex flex-col items-center text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-background-50/10 backdrop-blur-sm rounded-full border border-background-50/15 mb-8">
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
          <span className="text-background-50/90 text-sm font-medium">全网最大吃瓜群众聚集地 🍉</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-6 text-balance">
          黑料八卦每日大赛
          <br />
          <span className="text-accent-400">网红独家爆料</span> 尽在91吃瓜
        </h1>

        <p className="text-background-50/70 text-base md:text-lg max-w-2xl mb-10 leading-relaxed">
          每日更新最新娱乐圈八卦、网红独家爆料、社会热点事件。千万瓜友在线蹲瓜，黑料正能量不打烊，欢迎回家一起吃瓜。
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Link
            to="/category/daily-contest"
            className="px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full text-base font-medium transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            立即吃瓜
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/category/star-gossip"
            className="px-8 py-3.5 text-background-50/80 hover:text-background-50 rounded-full text-base font-medium transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            浏览热门爆料
            <i className="ri-arrow-right-line ml-1.5"></i>
          </Link>
        </div>

        <div className="mt-16 grid grid-cols-3 gap-4 md:gap-6 max-w-2xl w-full">
          {[
            { num: '286万+', label: '注册瓜友' },
            { num: '1589万+', label: '爆料帖子' },
            { num: '35.8万+', label: '日活用户' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">{stat.num}</div>
              <div className="text-background-50/50 text-xs md:text-sm mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}